const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    promoSendClaimCodeSocket({ getters, commit, dispatch }, data) {
        if(getters.socketSendLoading !== null) { return; }
        commit('socket_set_send_loading', 'PromoClaimCode');

        getters.socketClient.emit('general:promo:sendClaim', data, (res) => {
            if(res.success === true) {
                commit('auth_update_user', res.user);

                dispatch('modalsSetShow', null);
                dispatch('notificationShow', { type: 'success', message: 'You have successfully redeemed a promo code.' });
            } else {
                dispatch('notificationShow', res.error);
            }

            commit('socket_set_send_loading', null);
        });
    }
}

const promo = {
    state,
    mutations,
    actions,
    getters
}

export default promo;